import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { MarketingCampaign, Practice } from '@principle-theorem/principle-core';
import { IMarketingCampaign } from '@principle-theorem/principle-core/interfaces';
import { asReffable, toTimestamp, WithRef } from '@principle-theorem/shared';
import {
  CampaignSettingsFormComponent,
  IEditCampaignSettingsFormData,
} from '../campaign-settings-form/campaign-settings-form.component';

export interface ICampaignSettingsDialogRequest {
  campaign?: WithRef<IMarketingCampaign>;
}

export interface ICampaignSettingsDialogResponse {
  campaign: IMarketingCampaign;
}

@Component({
  selector: 'pr-campaign-settings-dialog',
  templateUrl: './campaign-settings-dialog.component.html',
  styleUrl: './campaign-settings-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, CampaignSettingsFormComponent],
})
export class CampaignSettingsDialogComponent {
  private _dialogRef =
    inject<
      MatDialogRef<
        CampaignSettingsDialogComponent,
        ICampaignSettingsDialogResponse
      >
    >(MatDialogRef);
  data = inject<ICampaignSettingsDialogRequest>(MAT_DIALOG_DATA);
  formValue = signal<IEditCampaignSettingsFormData | undefined>(undefined);

  async submit(): Promise<void> {
    const data = this.formValue();
    if (!data) {
      return;
    }
    const brandRef = Practice.brandRef(asReffable(data.practiceRef));

    const campaign = MarketingCampaign.init({
      brandRef,
      ...this.data?.campaign,
      ...data,
    });

    campaign.nextRunAt = await MarketingCampaign.getNextRunDate(
      campaign,
      toTimestamp()
    );
    this._dialogRef.close({ campaign });
  }
}
